/* eslint react/prop-types: 0 */
import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import {
  resolveHistoryTimezone,
  historyToday
} from '../../common/historyTimezone';

export const browserTimezone = resolveHistoryTimezone;
export const calendarToday = historyToday;
export const validHistoryDate = (date, today) =>
  /^\d{4}-\d{2}-\d{2}$/.test(date) &&
  date >= '0001-01-01' &&
  date <= today &&
  Number.isFinite(Date.parse(`${date}T00:00:00Z`)) &&
  new Date(`${date}T00:00:00Z`).toISOString().slice(0, 10) === date;

export default function HistoryDateControl({
  date,
  today,
  timezone,
  onChange
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        flexWrap: 'wrap',
        mb: 3
      }}
    >
      <TextField
        label="View date"
        type="date"
        size="small"
        value={date}
        InputLabelProps={{ shrink: true }}
        inputProps={{ min: '0001-01-01', max: today }}
        onChange={(event) => {
          if (validHistoryDate(event.target.value, today))
            onChange(event.target.value);
        }}
      />
      <Button onClick={() => onChange(today)} disabled={date === today}>
        Today
      </Button>
      <Typography variant="body2" color="text.secondary">
        {timezone}
      </Typography>
    </Box>
  );
}
